import { weenatIntl as wintl } from '@weenat/wintl';
import { isNil } from 'lodash-es';
import { Devices } from '../../enums';
function fromBrandEnumToLabel(brand) {
    if (isNil(brand)) {
        return '-';
    }
    else {
        switch (brand) {
            case Devices.Brand.pessl:
                return wintl.t('summaries.metric_providers.pessl');
            case Devices.Brand.weenat:
                return wintl.t('summaries.metric_providers.weenat');
            case Devices.Brand.davis:
                return wintl.t('summaries.metric_providers.davis');
            case Devices.Brand.adcon:
                return wintl.t('summaries.metric_providers.adcon');
            case Devices.Brand.corhize:
                return wintl.t('summaries.metric_providers.corhize');
        }
    }
}
export default fromBrandEnumToLabel;
